<template>
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="16" r="2" transform="rotate(-90 8 16)" />
        <circle cx="16" cy="16" r="2" transform="rotate(-90 16 16)" />
        <circle cx="24" cy="16" r="2" transform="rotate(-90 24 16)" />
    </svg>
</template>